import { Box } from '@factorialco/deprecated-design-system'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import CountriesArea from 'modules/marketplace/components/CountriesArea'
import DeveloperArea from 'modules/marketplace/components/DeveloperArea'
import 'modules/marketplace/components/Item/index.styles.css'
import SharingArea from 'modules/marketplace/components/SharingArea'
import SupportArea from 'modules/marketplace/components/SupportArea'

interface IntegrationAsideProps {
  integration: ItemIntegrationFragment
}

export const IntegrationAside = ({ integration }: IntegrationAsideProps) => {
  const { developer, countries, name } = integration
  return (
    <Box gap="s32" minWidth="s240" maxWidth="s300" className={'Item_boxContent'} paddingLeft="s12">
      {developer && <DeveloperArea developerInformation={developer} />}
      <SupportArea integration={integration} />
      {countries?.length && <CountriesArea countriesInformation={countries} />}
      <SharingArea moduleTitle={name} moduleUrl={window?.location?.href} />
    </Box>
  )
}
